import { render, staticRenderFns } from "./reImportDataPeserta.vue?vue&type=template&id=af8ce42a&"
import script from "./reImportDataPeserta.vue?vue&type=script&lang=js&"
export * from "./reImportDataPeserta.vue?vue&type=script&lang=js&"
import style0 from "./reImportDataPeserta.vue?vue&type=style&index=0&id=af8ce42a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports